import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import BankTxnListPageUI from './BankTxnListPageUI.js'
import LocalStorageKeys from '../../cache/LocalStorageKeys'

const Sort = {asc: 1, desc: 2, none: 0}

class BankTxnListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      txnList: null,
      filteredTxnList: null,
      alphaSort: Sort.none,
      timeSort: Sort.desc,
      searchFilter: ''
    }
  }

  render() {
    return (
      <BankTxnListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        txnList={this.state.txnList}
        filteredTxnList={this.state.filteredTxnList}
        alphaSort={this.state.alphaSort}
        timeSort={this.state.timeSort}
        searchFilter={this.state.searchFilter}
        // events
        onRefreshClick={this.onRefreshClick}
        onAlphaSortClick={this.onAlphaSortClick}
        onTimeSortClick={this.onTimeSortClick}
        onSearchFilterChange={this.onSearchFilterChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getTransactions(context)
    this.getMessages(context)
  }

  getTransactions(context) {
    if (!context.permissions) { // session expired for some reason
      localStorage.removeItem(LocalStorageKeys.Session)
      localStorage.removeItem(LocalStorageKeys.Session + ':CachedTime')
      setTimeout(() => {
        window.location = '/pub/message?key=invalid_session'
      }, 10)
      return
    }

    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/bankAccounts/VERT00000001/transactions`,
      cacheKey: CacheKeys.BankTxns(context.session.accountId),
      callback: this.getTransactionsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getTransactionsCallback = (response) => {
    let filtersStr = sessionStorage.getItem(CacheKeys.BankTxnsFilter(this.props.context.session.accountId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      errorList: response.errorList,
      txnList: response.transactionList,
      filteredTxnList: response.transactionList,
      alphaSort: filters.hasOwnProperty('alphaSort') ? filters.alphaSort : Sort.none,
      timeSort: filters.hasOwnProperty('timeSort') ? filters.timeSort : Sort.desc,
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
    })

    if (response.errorList.length > 0)
      return

    this.applyFilters(response.transactionList,
      filters.hasOwnProperty('alphaSort') ? filters.alphaSort : Sort.none,
      filters.hasOwnProperty('timeSort') ? filters.timeSort : Sort.desc,
      filters.searchFilter ? filters.searchFilter : '')
  }

  applyFilters(txnList, alphaSort, timeSort, searchFilter) {
    let filteredList = txnList.sort((p1, p2) => {
      if (alphaSort)
        return alphaSort === Sort.asc ?
          p1.payee.localeCompare(p2.description) : p2.payee.localeCompare(p1.description)
      if (timeSort)
        return timeSort === Sort.asc ?
          p1.transactionDate - p2.transactionDate : p2.transactionDate - p1.transactionDate
      return 0
    })

    if (searchFilter)
      filteredList = filteredList.filter(txn => txn.description.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()))

    this.setState({filteredTxnList: filteredList})

    let filters = {
      alphaSort: alphaSort,
      timeSort: timeSort,
      searchFilter: searchFilter,
    }
    sessionStorage.setItem(CacheKeys.BankTxnsFilter(this.props.context.session.accountId), JSON.stringify(filters))
  }

  onAlphaSortClick = () => {
    let alphaSort = this.state.alphaSort === Sort.asc ? Sort.desc : Sort.asc
    this.setState({
      alphaSort: alphaSort,
      timeSort: Sort.none
    })
    this.applyFilters(this.state.txnList, alphaSort, Sort.none,
      this.state.searchFilter)
  }

  onTimeSortClick = () => {
    let timeSort = this.state.timeSort === Sort.asc ? Sort.desc : Sort.asc
    this.setState({
      timeSort: timeSort,
      alphaSort: Sort.none
    })
    this.applyFilters(this.state.txnList, Sort.none, timeSort,
      this.state.searchFilter)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({searchFilter: searchFilter})
    this.applyFilters(this.state.txnList, this.state.alphaSort, this.state.timeSort,
      searchFilter)
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.BankTxns(context.session.accountId))
    this.setState({
      errorList: null,
      txnList: null,
      filteredTxnList: null
    })
    this.getTransactions(context)
  }

  getMessages(context) {
    let arr = [
      'c_no_txn_msg',
      'c_refresh',
      'c_sort_alpha',
      'c_sort_time',
      'c_card_txns',
      'c_bank_txns'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_card_txns', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(BankTxnListPageSF)
